export default __webpack_public_path__ + "static/media/underwear.074f48c9.png";